import { Container } from "@/Components/Common/Tailwind";

function MembershipTicketSection({ membership }) {
    return (
        <div>
            <Container>
                <div>
                    준비중입니다.
                </div>
            </Container>
        </div>
    );
}
export default MembershipTicketSection;